<app-dialog *ngIf="openCookiesDialog" flexibility="full"
  [confirmButtonLabel]="!cookiesAccepted ? multiLanguageMessageService.dictionary('sidAccept') : ''"
  [declineButtonLabel]="cookiesAccepted ? multiLanguageMessageService.dictionary('sidClose') : ''"
  (output)="onCookiesOutput($event)" (overlayclick)="openCookiesDialog = false">
  <app-cookie-notice></app-cookie-notice>
</app-dialog>